<style>
.el-dialog-div {
  height: 550px;
}

</style>
<template>
  <el-row>
    <table-template ref="searchTable" :queryParams="queryParams"
                    actionUrl="/businessIntranet/findBusiness.action">
      <template slot="search">
        <el-form :inline="true">
          <el-form-item v-belong-to-admin>
            <channel-select ref="channelSelect" :clearable="true" :filterable="true" placeholder="展示渠道"
                            @change="channelIdsChange"></channel-select>
          </el-form-item>

          <el-form-item>
            <el-select v-model="queryParams.customerType" clearable placeholder="跟进状态"
                       @change="$refs['searchTable'].search()">
              <el-option :value="1" label="待跟进"></el-option>
              <el-option :value="2" label="全部"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-select v-model="queryParams.memberType" clearable placeholder="用户类型"
                       @change="$refs['searchTable'].search()">
              <el-option :value="1" label="普通用户"></el-option>
              <el-option :value="3" label="卖车通会员"></el-option>

              <el-option :value="5" label="买卖通会员"></el-option>
              <el-option :value="6" label="专享通会员"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-select v-model="queryParams.levelType" clearable placeholder="用户等级"
                       @change="$refs['searchTable'].search()">
              <el-option :value="'高'" label="高"></el-option>
              <el-option :value="'中'" label="中"></el-option>
              <el-option :value="'低'" label="低"></el-option>
              <el-option :value="'无意向'" label="无意向"></el-option>
              <el-option :value="'未知'" label="未知"></el-option>
              <el-option :value="'非车商'" label="非车商"></el-option>
              <el-option :value="'已注销'" label="已注销"></el-option>
              <el-option :value="'代理'" label="代理"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-select v-model="queryParams.isSubscribe" clearable placeholder="是否关注"
                       @change="$refs['searchTable'].search()">
              <el-option :value="1" label="已关注"></el-option>
              <el-option :value="2" label="未关注"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-select v-model="queryParams.ifInviter" clearable placeholder="是否有邀请人"
                       @change="$refs['searchTable'].search()">
              <el-option :value="1" label="无邀请人"></el-option>
              <el-option :value="2" label="有邀请人"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-select v-model="queryParams.ifMainTennace" clearable placeholder="是否有维护人"
                       @change="$refs['searchTable'].search()">
              <el-option :value="1" label="无维护人"></el-option>
              <el-option :value="2" label="有维护人"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="queryParams.isHasWechat" clearable placeholder="是否有微信"
                       @change="$refs['searchTable'].search()">
              <el-option :value="1" label="无"></el-option>
              <el-option :value="2" label="有"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <employee-select placeholder="请选择维护人" @clear="clear"
                             @onEmployeeSelected="onEmployeeSelectedQuery"></employee-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="queryParams.viewStatus" :clearable="true" placeholder="状态"
                       @change="onStatusChange">
              <el-option :value="1" label="上架"></el-option>
              <el-option :value="2" label="下架"></el-option>
              <el-option :value="5" label="仅注册"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>

            <el-input v-model="queryParams.keyword" placeholder="商家名/电话/地址/微信号"></el-input>

          </el-form-item>
          <el-form-item>

            <el-input v-model="queryParams.inviterPhone" placeholder="邀请人手机号"></el-input>

          </el-form-item>
          <el-form-item>
            <el-date-picker v-model="queryParams.createTime" start-placeholder="创建开始时间" end-placeholder="创建结束时间"
                            type="daterange" @change="onCreateTimeChange">
            </el-date-picker>
          </el-form-item>

          <el-form-item>
            <el-date-picker v-model="queryParams.loginTime" start-placeholder="登录开始时间" end-placeholder="登录结束时间"
                            type="daterange" @change="onLoginTimeChange">
            </el-date-picker>
          </el-form-item>

          <el-form-item>
            <el-date-picker v-model="queryParams.visitTime" start-placeholder="下次跟进开始时间" end-placeholder="下次跟进结束时间"
                            type="daterange" @change="onVisitTimeChange">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-date-picker v-model="queryParams.soonVisitTime" start-placeholder="最近跟进开始时间" end-placeholder="最近跟进结束时间"
                            type="daterange" @change="onSoonVisitTimeChange">
            </el-date-picker>
          </el-form-item>

          <el-form-item>
            <el-date-picker v-model="queryParams.receiveTime" start-placeholder="领取开始时间" end-placeholder="领取结束时间"
                            type="daterange" @change="onReceiveTimeChange">
            </el-date-picker>
          </el-form-item>

          <el-form-item>
            <el-date-picker v-model="queryParams.actionLastTime" start-placeholder="最近操作开始时间" end-placeholder="最近操作结束时间"
                            type="daterange" @change="onActionLastTimeChange">
            </el-date-picker>
          </el-form-item>

          <el-form-item>
            <el-date-picker v-model="queryParams.memberEndTimeAr" start-placeholder="到期开始时间" end-placeholder="到期结束时间"
                            type="datetimerange" @change="onMemberEndTimeChange">
            </el-date-picker>
          </el-form-item>
          <el-form-item >
            <el-input type="number" v-model="queryParams.gtProfitMoney"  placeholder=">=收益金额(元)"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="search()">搜索</el-button>

          </el-form-item>
          <el-form-item v-permissions="'exportIntranetBus'">
            <el-button @click="excelExport()">导出</el-button>
          </el-form-item>
        </el-form>
      </template>
      <template slot="item">
        <el-table-column
            label="用户信息"
            prop="phone">
          <template scope="scope">
            <span style="font-size: 18px;font-weight: bold">{{ scope.row.phone }}</span><span
              style="padding-left: 10px">{{ scope.row.contacts }}</span>
            <p>地区：{{ scope.row.city }}</p>
            <p>邀请人：{{ scope.row.inviterIntranetName }}-{{ scope.row.inviterIntranetPhone }}</p>
            <p>微信号：{{ scope.row.wechat ? scope.row.wechat : '无' }}</p>
            <p>openID：{{ scope.row.miniOpenId }}({{ scope.row.isSubscribe == 1 ? '已关注' : '未关注' }})</p>
            <p>到期会员是否同步：<span style="color:red" v-if="scope.row.synFriend == 1">同步</span> <span v-if="scope.row.synFriend == 2">不同步</span> </p>

          </template>
        </el-table-column>
        <el-table-column
            label="用户类型"
            prop="memberType">
          <template scope="scope">
            <p>用户类型：{{ scope.row.memberType | memberTypeFilter }}<span style="color:red" v-if="scope.row.levelType">({{ scope.row.levelType }})</span></p>
            <p>会员到期：{{
                scope.row.businessEndTime |
                    dateTimeFormat
              }}
              <span style="color:red" v-if="scope.row.businessEndDays">(已到期{{ scope.row.businessEndDays }}天)</span>
            </p>
            <p>可用线索/人脉/群/保证金/收益：{{ scope.row.canUsedCount }}/{{scope.row.contactsCanUsedCount}}/{{scope.row.groupCanUsedCount}}/{{scope.row.bondCanUsedMoney/100}}
              /{{scope.row.profitCanUsedMoney/100}}</p>
            <p style="font-size: 20px;">累积访客：{{ scope.row.totalBusinessBrowseCount }}(今日+{{scope.row.todayBusinessBrowseCount}})</p>

          </template>
        </el-table-column>
        <el-table-column
            label="用户行为"
            prop="action">
          <template scope="scope">
            <p>创建时间：{{
                scope.row.createTime |
                    dateTimeFormat
              }}</p>
            <p>最近登录：{{
                scope.row.lastLoginTime |
                    dateTimeFormat
              }}</p>
            <p>最近操作：{{ scope.row.actionTime|dateTimeFormat }}</p>
            <p>操作行为：{{ scope.row.actionContent ? scope.row.actionContent : '无' }}<span v-if="scope.row.actionContent"
                                                                                       style="color:red">(总行为{{ scope.row.actionCount }}次)</span>
            </p>
          </template>
        </el-table-column>

        <el-table-column
            label="维护跟进">
          <template scope="scope">
            <p>维护人：{{ scope.row.maintenanceName ? scope.row.maintenanceName : '无' }}</p>
            <p style="color:red">下次跟进：{{ scope.row.nextVideviceIntranetManagementsitTime|dateTimeFormat }}</p>
            <p>领取时间：{{ scope.row.receiveTime|dateTimeFormat }}</p>
            <p>最近跟进：{{ scope.row.lastVisitTime|dateTimeFormat }}</p>
            <p>跟进内容：{{ scope.row.visitContent }}</p>
          </template>
        </el-table-column>

        <el-table-column
            label="操作">
          <template scope="scope">
            <el-dropdown>

               <span class="el-dropdown-link">
                  更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                    @click.native.prevent="$router.push({name:'收益记录', query: { employeeId: scope.row.employeeId }})">收益记录
                </el-dropdown-item>
                <el-dropdown-item
                      @click.native.prevent="$router.push({name:'跟进记录', query: { businessId: scope.row.id }})">跟进记录
              </el-dropdown-item>

                <el-dropdown-item
                        @click.native.prevent="$router.push({name:'内网权益记录', query: { businessId: scope.row.id }})">权益记录
                </el-dropdown-item>
                <el-dropdown-item
                        @click.native.prevent="$router.push({name:'人脉明细', query: { businessId: scope.row.id }})">人脉明细
                </el-dropdown-item>

                <el-dropdown-item
                    @click.native.prevent="$router.push({path:'/home/distributionBusinessMaintenanceEmployee', query:{'businessId':scope.row.id}})">
                  分配维护人
                </el-dropdown-item>
                <el-dropdown-item v-confirm-input :confirm-input-data="{id:scope.row.id}" confirm-input-placeholder="请输入邀请人手机号"
                                  confirm-input-text="确定修改邀请人关系" requestUrl="lcwpbusiness/updateInviteAccount.action"
                                  value-alias="phone" @onInputConfirm="onInputConfirm">绑定邀请人
                </el-dropdown-item>
                <el-dropdown-item v-confirm-input :confirm-input-data="{id:scope.row.id}" confirm-input-placeholder="请输入微信号"
                                  confirm-input-text="确定修改微信号" requestUrl="lcwpbusiness/updateWechat.action"
                                  value-alias="wechat" :value-no-required="true" @onInputConfirm="onInputConfirm">绑定微信号
                </el-dropdown-item>
                <el-dropdown-item
                    @click.native.prevent="$router.push({path:'/home/plusIntranetBusinessTabIndex/wxNoticeSetting', query:{'businessId':scope.row.id}})">
                  修改微信通知
                </el-dropdown-item>
                <el-dropdown-item
                    @click.native.prevent="$router.push({path:'/home/plusIntranetBusinessTabIndex/setBusinessIntranetExtend', query:{'businessId':scope.row.id}})">
                  修改用户等级
                </el-dropdown-item>
                <el-dropdown-item v-confirm-input :confirm-input-data="{id:scope.row.id}" confirm-input-text="确定修改手机号"
                                  requestUrl="lcwpbusiness/updateLoginAccount.action" value-alias="phone"
                                  @onInputConfirm="onInputConfirm">修改手机号
                </el-dropdown-item>
                <el-dropdown-item @click.native.prevent="$router.push({name:'修改plus商家', params: { id: scope.row.id }})">
                  修改商家
                </el-dropdown-item>
                <el-dropdown-item v-confirm
                                  :confirm-data="{id:scope.row.id,status:scope.row.status==1?2:1}"
                                  :confirm-text="scope.row.status==1?'确认下架该商家？':'确认上架该商家？'"
                                  :style="{color:scope.row.status==1?'#f55c5c':'#57c23a'}"
                                  requestUrl="lcwpbusiness/changeBusinessStatus.action"
                                  @onConfirm="$refs['searchTable'].search()">
                  {{ scope.row.status == 1 ? '下架商家' : '上架商家' }}
                </el-dropdown-item>

                <el-dropdown-item v-confirm
                                  :confirm-data="{id:scope.row.id,synFriend:scope.row.synFriend==1?2:1}"
                                  :confirm-text="scope.row.synFriend==1?'到期会员确认不同步该商家朋友圈？':'到期会员确认同步该商家朋友圈？'"
                                  :style="{color:scope.row.synFriend==1?'#f55c5c':'#57c23a'}"
                                  requestUrl="lcwpbusiness/changeBusinessSynFriend.action"
                                  @onConfirm="$refs['searchTable'].search()">
                  {{ scope.row.synFriend == 1 ? '到期会员不同步' : '到期会员同步' }}
                </el-dropdown-item>

                <el-dropdown-item
                        @click.native.prevent="$router.push({path:'/home/refundBusinessBond', query:{'businessId':scope.row.id}})">
                  退保证金
                </el-dropdown-item>
                <el-dropdown-item
                    @click.native.prevent="$router.push({path:'/home/refundBusinessProfit', query:{'businessId':scope.row.id}})">
                  扣减收益
                </el-dropdown-item>

                <el-dropdown-item
                    @click.native.prevent="$router.push({path:'/home/accountManage', query:{'businessId':scope.row.id}})">
                  账户管理
                </el-dropdown-item>

                <!--    <el-dropdown-item v-confirm-input :confirm-input-data="{id:scope.row.id}" confirm-input-text="确定排序商家"
                                      confirm-input-type="number" requestUrl="lcwpbusiness/updateSortNum.action"
                                      @onInputConfirm="onInputConfirm">排序
                    </el-dropdown-item>

                    <el-dropdown-item v-confirm
                                      :confirm-data="{id:scope.row.id,status:4}"
                                      confirm-text="确认删除该商家"
                                      :style="{color:scope.row.status==1?'#f55c5c':'#57c23a'}"
                                      requestUrl="lcwpbusiness/changeBusinessStatus.action" @onConfirm="$refs['searchTable'].search()">
                      删除
                    </el-dropdown-item>-->

              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </template>
    </table-template>
  </el-row>
</template>

<script>
import TableTemplate from '@/components/TableTemplate'
import BasicPager from '@/mixins/BasicPager'
import channelSelect from '@/components/channelSelect'
import JoinCarShowDialog from './children/JoinCarShowDialog'
import setDeviceType from './children/setDeviceType'
import setMungBean from './children/setMungBean'
import BasicModel from '@/framework/basic/BasicModel'
import DateUtil from '@/framework/utils/DateUtil'
import Config from '@/framework/configs/Config'
import EmployeeSelect from '@/components/EmployeeSelect'

export default {
  name: 'joined-intranet-business',
  extends: BasicPager,
  data: function () {
    return {
      orderCurrentPage: 1, // 起始
      orderPageSize: 10, // 步长
      orderTotalCount: 0, // 总条数
      orderMoney: 0, // 交易金额
      money: 0, // 结算金额
      dialogOrderFormVisible: false,
      businessStaticData: {},
      dialogStaticDataVisible: false,
      orderDatas: null,
      dialogOrderForm: {
        startEndTime: null,
        startTime: null,
        endTime: null,
        businessId: null
      },
      queryParams: {
        gtProfitMoney: null,
        businessId: null,
        createTime: '',
        loginTime: '',
        visitTime: '',
        startTime: null,
        endTime: null,
        loginStartTime: null,
        loginEndTime: null,
        visitStartTime: null,
        visitEndTime: null,
        keyword: '',
        inviterPhone: null,
        type: null,
        channelId: null,
        ifInviter: null,
        ifMainTennace: null,
        isHasWechat: null,
        customerType: null,
        memberType: null,
        isSubscribe: null,
        levelType: null,
        soonVisitTime: null,
        soonVisitStartTime: null,
        soonVisitEndTime: null,
        actionLastTime: null,
        actionLastStartTime: null,
        actionLastEndTime: null,
        memberStartTime: null,
        memberEndTime: null,
        receiveTime: null

      }
    }
  },
  components: {
    TableTemplate,
    channelSelect,
    JoinCarShowDialog,
    setDeviceType,
    setMungBean,
    EmployeeSelect
  },

  filters: {
    memberTypeFilter: function (valueFilter) {
      let str = ''
      switch (valueFilter) {
        case 1:
          str = '普通用户'
          break
        case 3:
          str = '卖车通会员'
          break
        case 4:
          str = '收车通会员'
          break
        case 5:
          str = '买卖通会员'
          break
        case 6:
          str = '专享通会员'
          break
        default:
          str = '普通用户'
      }

      return str
    },
    statusFilter: function (valueFilter) {
      let str = ''
      switch (valueFilter) {
        case 2:
          str = '已下架'
          break
        case 1:
          str = '已上架'
          break
        default:
          str = '暂无'
      }

      return str
    },
    deviceTypeFilter: function (valueFilter) {
      let str = ''
      switch (valueFilter) {
        case 1:
          str = '关闭安装点'
          break
        case 2:
          str = '普通安装点'
          break
        default:
          str = '区域独家安装点'
      }

      return str
    }
  },
  created: function () {
    if (this.loginInfo.loginPath === 'channel') {
      this.queryParams.channelId = this.loginInfo.id
    }

    this.dialogOrderForm.startEndTime = [DateUtil.getNDayTime(-30), DateUtil.getDayEndTime()]
  },
  activated: function () {
    // this.queryParams.createTime = [DateUtil.getNDayTime(-90), DateUtil.getDayEndTime()]
    //
    // this.queryParams.startTime = this.queryParams.createTime[0].getTime()
    //
    // this.queryParams.endTime = this.queryParams.createTime[1].getTime()

    this.$refs.searchTable.search()
  },
  methods: {
    clear: function () {
      this.queryParams.maintenanceEmployeeSnapId = null
      this.$refs['searchTable'].search()
    },
    onEmployeeSelectedQuery: function (item) {
      this.queryParams.maintenanceEmployeeSnapId = item.snapshotId
      this.$refs['searchTable'].search()
    },
    excelExport: function () {
      let userInfo = this.getLoginInfo()
      let loginPath = userInfo.loginPath
      let id = null
      if (userInfo.id) {
        id = userInfo.id
      } else if (userInfo.employeeId) {
        id = userInfo.employeeId
      }

      let url = Config.baseUrl + '/businessIntranet/exportSecondBusinessList.action?token=' + userInfo.token + '&loginAccountId=' + id + '&loginPath=' + loginPath
      if (this.queryParams.channelId) {
        url = url + '&channelId=' + this.queryParams.channelId
      }
      if (this.queryParams.status) {
        url = url + '&status=' + this.queryParams.status
      }
      if (this.queryParams.keyword) {
        url = url + '&keyword=' + this.queryParams.keyword
      }
      if (this.queryParams.startTime) {
        url = url + '&startTime=' + this.queryParams.startTime
      }
      if (this.queryParams.endTime) {
        url = url + '&endTime=' + this.queryParams.endTime
      }

      if (this.queryParams.loginStartTime) {
        url = url + '&loginStartTime=' + this.queryParams.loginStartTime
      }
      if (this.queryParams.loginEndTime) {
        url = url + '&loginEndTime=' + this.queryParams.loginEndTime
      }

      if (this.queryParams.visitStartTime) {
        url = url + '&visitStartTime=' + this.queryParams.visitStartTime
      }
      if (this.queryParams.visitEndTime) {
        url = url + '&visitEndTime=' + this.queryParams.visitEndTime
      }
      if (this.queryParams.soonVisitStartTime) {
        url = url + '&soonVisitStartTime=' + this.queryParams.soonVisitStartTime
      }
      if (this.queryParams.soonVisitEndTime) {
        url = url + '&soonVisitEndTime=' + this.queryParams.soonVisitEndTime
      }
      if (this.queryParams.actionLastStartTime) {
        url = url + '&actionLastStartTime=' + this.queryParams.actionLastStartTime
      }
      if (this.queryParams.actionLastEndTime) {
        url = url + '&actionLastEndTime=' + this.queryParams.actionLastEndTime
      }

      if (this.queryParams.memberStartTime) {
        url = url + '&memberStartTime=' + this.queryParams.memberStartTime
      }
      if (this.queryParams.memberEndTime) {
        url = url + '&memberEndTime=' + this.queryParams.memberEndTime
      }

      if (this.queryParams.maintenanceEmployeeSnapId) {
        url = url + '&maintenanceEmployeeSnapId=' + this.queryParams.maintenanceEmployeeSnapId
      }
      if (this.queryParams.ifInviter) {
        url = url + '&ifInviter=' + this.queryParams.ifInviter
      }
      if (this.queryParams.ifMainTennace) {
        url = url + '&ifMainTennace=' + this.queryParams.ifMainTennace
      }
      if (this.queryParams.isHasWechat) {
        url = url + '&isHasWechat=' + this.queryParams.isHasWechat
      }
      if (this.queryParams.inviterPhone) {
        url = url + '&inviterPhone=' + this.queryParams.inviterPhone
      }

      if (this.queryParams.memberType) {
        url = url + '&memberType=' + this.queryParams.memberType
      }

      if (this.queryParams.customerType) {
        url = url + '&customerType=' + this.queryParams.customerType
      }
      if (this.queryParams.isSubscribe) {
        url = url + '&isSubscribe=' + this.queryParams.isSubscribe
      }
      if (this.queryParams.levelType) {
        url = url + '&levelType=' + this.queryParams.levelType
      }
      window.open(url)
    },
    // 监听页数变化
    handleOrderSizeChange (val) {
      this.orderPageSize = val
      this.loadOrderData()
    },
    // 监听页码变化
    handleOrderCurrentChange (val) {
      this.orderCurrentPage = val
      this.loadOrderData()
    },
    showOrderData: function (id) {
      this.dialogOrderForm.businessId = id
      this.loadOrderData()
      this.dialogOrderFormVisible = true
    },
    handleTime: function () {
      this.orderCurrentPage = 1
      this.loadOrderData()
    },
    loadOrderData: function () {
      let _this = this
      let params = {
        businessId: this.dialogOrderForm.businessId,
        pageNum: this.orderCurrentPage,
        pageSize: this.orderPageSize

      }

      if (_this.dialogOrderForm.startEndTime && _this.dialogOrderForm.startEndTime.length === 2) {
        let startTime = _this.dialogOrderForm.startEndTime[0]
        let endTime = _this.dialogOrderForm.startEndTime[1]
        if (startTime) {
          params.startTime = startTime.getTime()
        }
        if (endTime) {
          params.endTime = endTime.getTime()
        }
      }

      let listener = {
        success: function (dataInfo) {
          _this.orderDatas = dataInfo.datas.result
          _this.orderTotalCount = dataInfo.datas.total
          _this.orderMoney = dataInfo.datas.orderMoney
          _this.money = dataInfo.datas.money
        }
      }
      let action = 'lcwpbusiness/findTransactionDetails.action'
      BasicModel.get(this, action, params, listener)
    },
    showStaticData: function (id) {
      this.loadStaticData(id)
      this.dialogStaticDataVisible = true
    },
    loadStaticData: function (id) {
      let _this = this
      let params = {
        businessId: id
      }

      let listener = {
        success: function (dataInfo) {
          _this.businessStaticData = dataInfo.datas
        }
      }
      let action = 'lcwpbusiness/getBusinessStaticData.action'
      BasicModel.get(this, action, params, listener)
    },
    showDeviceType: function (data) {
      this.$refs['setDeviceType'].showDeviceType(data)
    },
    showMungBean: function (data) {
      this.$refs['setMungBean'].showMungBean(data)
    },
    search () {
      this.$refs['searchTable'].search()
    },
    showJoinCarShowDialog (data) {
      let businessId = data.id
      let carShowId = data.carShowId
      let carShowName = data.carShowName
      this.$refs['joinCarShowDialog'].showDialog(businessId, carShowId, carShowName)
    },
    onCreateTimeChange: function () {
      let createTime = this.queryParams.createTime

      if (createTime && createTime[0]) {
        this.queryParams.startTime = createTime[0].getTime()
        this.queryParams.endTime = createTime[1].getTime()
      } else {
        this.queryParams.startTime = null
        this.queryParams.endTime = null
      }

      this.$refs['searchTable'].search()
    },
    onVisitTimeChange: function () {
      let visitTime = this.queryParams.visitTime

      if (visitTime && visitTime[0]) {
        this.queryParams.visitStartTime = visitTime[0].getTime()
        this.queryParams.visitEndTime = visitTime[1].getTime()
      } else {
        this.queryParams.visitStartTime = null
        this.queryParams.visitEndTime = null
      }

      this.$refs['searchTable'].search()
    },
    onReceiveTimeChange: function () {
      let visitTime = this.queryParams.receiveTime

      if (visitTime && visitTime[0]) {
        this.queryParams.receiveStartTime = visitTime[0].getTime()
        this.queryParams.receiveEndTime = visitTime[1].getTime()
      } else {
        this.queryParams.receiveStartTime = null
        this.queryParams.receiveEndTime = null
      }

      this.$refs['searchTable'].search()
    },
    onSoonVisitTimeChange: function () {
      let visitTime = this.queryParams.soonVisitTime

      if (visitTime && visitTime[0]) {
        this.queryParams.soonVisitStartTime = visitTime[0].getTime()
        this.queryParams.soonVisitEndTime = visitTime[1].getTime()
      } else {
        this.queryParams.soonVisitStartTime = null
        this.queryParams.soonVisitEndTime = null
      }

      this.$refs['searchTable'].search()
    },
    onActionLastTimeChange: function () {
      let actionLastTime = this.queryParams.actionLastTime

      if (actionLastTime && actionLastTime[0]) {
        this.queryParams.actionLastStartTime = actionLastTime[0].getTime()
        this.queryParams.actionLastEndTime = actionLastTime[1].getTime()
      } else {
        this.queryParams.actionLastStartTime = null
        this.queryParams.actionLastEndTime = null
      }

      this.$refs['searchTable'].search()
    },
    onMemberEndTimeChange: function () {
      let memberEndTimeAr = this.queryParams.memberEndTimeAr
      if (memberEndTimeAr && memberEndTimeAr[0]) {
        this.queryParams.memberStartTime = memberEndTimeAr[0].getTime()
        this.queryParams.memberEndTime = memberEndTimeAr[1].getTime()
      } else {
        this.queryParams.memberStartTime = null
        this.queryParams.memberEndTime = null
      }

      this.$refs['searchTable'].search()
    },
    onLoginTimeChange: function () {
      let loginTime = this.queryParams.loginTime

      if (loginTime && loginTime[0]) {
        this.queryParams.loginStartTime = loginTime[0].getTime()
        this.queryParams.loginEndTime = loginTime[1].getTime()
      } else {
        this.queryParams.loginStartTime = null
        this.queryParams.loginEndTime = null
      }

      this.$refs['searchTable'].search()
    },
    channelIdsChange: function (channelId) {
      if (channelId) {
        this.queryParams.channelId = channelId
      } else {
        this.queryParams.channelId = null
      }

      this.$refs['searchTable'].search()
    },
    onStatusChange: function (value) {
      if (value) {
        this.queryParams.status = value
      } else {
        this.queryParams.status = null
      }
      this.$refs['searchTable'].search()
    },

    onInputConfirm: function () {
      this.$refs['searchTable'].search()
    }
  }
}
</script>

<style lang="css" scoped>
.el-row {
  margin-bottom: 20px;

}

.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}
</style>
